export default "__VITE_ASSET__Dnf6Jc06__"